import request from '@/utils/request'

let Service_sApi = {

  /*预约服务列表*/
  list(data) {
    return request._post('/shop/plus.service_s.Index/index', data);
},
/*添加预约服务*/
add(data) {
    return request._post('/shop/plus.service_s.Index/add', data);
},
/*修改预约服务*/
edit(data) {
    return request._post('/shop/plus.service_s.Index/edit', data);
},
/*删除预约服务*/
del(data) {
    return request._post('/shop/plus.service_s.Index/del', data);
},
/*预约服务详情*/
detail(data) {
  return request._post('/shop/plus.service_s.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.service_s.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.service_s.Setting/getSetting', data, errorback);
    },
}
export default Service_sApi;



// WEBPACK FOOTER //
// ./src/api/service_s.js